<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Monitoring Report</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="AddMeasurerItemsForm">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Select Month</label>
                    <ng-select  class="form-control" 
                                        [(ngModel)]="selectedMonthsDates"
                                        formControlName="Months"
                                       >
                                       <ng-option *ngFor="let date of availableDatesMonthes" [value]="date"
                                       >{{ date | date: 'MMMM yyyy'
                                                }}
                                      </ng-option>
                                      </ng-select>
                                        <!-- <mat-select [(ngModel)]="selectedMonthsDates"
                                            [ngModelOptions]="{standalone: true}"
                                            (selectionChange)="onMonthsSelectionChange($event)" >
                                            <mat-option *ngFor="let date of availableDatesMonthes" [value]="date"
                                                [disabled]="isMonthsDateDisabled(date)">{{ date | date: 'MMMM yyyy'
                                                }}</mat-option>
                                        </mat-select> -->
                          </div>
                                </div>
                <div class="col-md-6 ">
                  <div class="form-group">
                    <label>Branch</label>
                    <ng-select class="form-control" 
                      [items]="AllBranchs" 
                      bindLabel="name" 
                      bindValue="id" 
                      formControlName="Branch">
                    </ng-select>
                    <mat-error class="mt-2"
                      *ngIf="fc.Branch.invalid && (fc.Branch.dirty || fc.Branch.touched)">
                      Branch is required
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-6 ">
                  <div class="form-group">
                    <label>Item Type</label>
                    <ng-select class="form-control" 
                      [items]="ItemTypes" 
                      bindLabel="name" 
                      bindValue="id" 
                      formControlName="ItemType">
                    </ng-select>
                    <mat-error class="mt-2"
                      *ngIf="fc.ItemType.invalid && (fc.ItemType.dirty || fc.ItemType.touched)">
                      Item Type is required
                    </mat-error>
                  </div>
                </div>
                    <div class="col-md-6"  >
                  <div class="form-group">
                    <label>Item</label>
                    <ng-select class="form-control"  
                      formControlName="Item">
                      <ng-option *ngFor="let item of MeasurerItemstofilter" [value]="item.id">
                        {{item.ItemName  + ' / ' + item.Code }}
                      </ng-option>
                    </ng-select>
                    <mat-error class="mt-2"
                      *ngIf="fc.Item.invalid && (fc.Item.dirty || fc.Item.touched)">
                      Item is required
                    </mat-error>
                  </div>
                </div>
              
              </div>
              <button mat-raised-button type="submit"  class="btn primary pull-right" [disabled]="AddMeasurerItemsForm.invalid" (click)="Search()">Search</button>
              <div class="clearfix"></div>
            </form>
<div *ngIf="searchclicked">  
  <div class="col-md-12">
    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportToPDF()" class="mb-4 p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
</div>



 <table id="pdfTable" mat-table [dataSource]="dataSource" class="mat-elevation-z8 full-border-table text-center">
    <ng-container matColumnDef="ItemData">
        <td mat-header-cell *matHeaderCellDef colspan="12">
            <div class="row text-center mb-2">
                <div class="col-4">
                    <strong>Code : </strong>
                    <span class="PassColor">{{code}}</span>
                </div>
                <div class="col-4">
                    <strong>Name : </strong>
                    <span class="FailColor">{{name}}</span>
                </div>
                <div class="col-4">
                    <strong>Branch : </strong>
                    <span class="FailColor">{{branch}}</span>
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="dateHeader">
        <td mat-header-cell *matHeaderCellDef colspan="12">
            <div class="row text-center mb-2">
                <div class="col-6">
                    <strong>Month : </strong>
                    <span class="PassColor">{{month}}</span>
                </div>
                <div class="col-6">
                    <strong>Year : </strong>
                    <span class="FailColor">{{year}}</span>
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="Day">
        <th mat-header-cell *matHeaderCellDef class="text-center FontBold compact-header">Day</th>
        <td mat-cell *matCellDef="let element" class="FontBold compact-cell">{{element.day}}</td>
    </ng-container>

   
    <ng-container matColumnDef="No1">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold">No. 1</th>
      <td mat-cell *matCellDef="let element" class="FontBold compact-cell" [class.empty-cell]="element.No1.length == 0">
        <ng-container *ngIf="element.No1 && element.No1.length > 0" >
          <div class="value-container">
            <div *ngFor="let value of element.No1; let i = index" class="value-item" [ngStyle]="{
              'background-color': (i === 0 && compareValues(value, tempValue, tempOperator)) || 
                       (i === 1 && compareValues(value, humValue, humOperator)) ? 'red' : 'inherit'
            }" >
              <span>
                {{ i === 0 ? 'T: ' : i === 1 ? 'RH: ' : '' }}
              </span>
              <span>
                {{ value | number: '1.0-0' }}
              </span>  
                          <span>
                {{ i === 0 ? '°C' : i === 1 ? '%' : '' }}
              </span>
            </div>
          </div>
          <small class="time-label">{{ element.Date1 | date: 'shortTime' }}</small>
        </ng-container>
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="No1">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold compact-header">
        No. 1
      </th>
      <td mat-cell *matCellDef="let element" class="FontBold" style="padding: 0%;  margin: 0%;">
        <ng-container *ngIf="element.No1 && element.No1.length > 0" style="padding: 0%;  margin: 0%;">
              <span  *ngFor="let value of element.No1; let i = index">
                <span>
                  {{ i === 0 ? 'T: ' : i === 1 ? 'RH: ' : '' }}
                </span>
                {{ value }} 
                 <span>
                  {{ i === 0 ? 'c°' : i === 1 ? '%' : '' }}
                </span>
              </span>
            <span>{{ element.Date1 | date: 'shortTime' }}</span>
        </ng-container>
      </td>
    </ng-container> -->
    

    <ng-container matColumnDef="No2">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold">No. 2</th>
      <td mat-cell *matCellDef="let element" class="FontBold compact-cell" [class.empty-cell]="element.No2.length == 0">
        <ng-container *ngIf="element.No2 && element.No2.length > 0">
          <div class="value-container">
            <div *ngFor="let value of element.No2; let i = index" class="value-item" [ngStyle]="{
              'background-color': (i === 0 && compareValues(value, tempValue, tempOperator)) || 
                       (i === 1 && compareValues(value, humValue, humOperator)) ? 'red' : 'inherit'
            }">
              <span>
                {{ i === 0 ? 'T: ' : i === 1 ? 'RH: ' : '' }}
              </span>
              <span>
                {{ value | number: '1.0-0' }}
              </span>  
                          <span>
                {{ i === 0 ? '°C' : i === 1 ? '%' : '' }}
              </span>
            </div>
          </div>
          <small class="time-label">{{ element.Date2 | date: 'shortTime' }}</small>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="No3">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold">No. 3</th>
      <td mat-cell *matCellDef="let element" class="FontBold compact-cell" [class.empty-cell]="element.No3.length == 0">
        <ng-container *ngIf="element.No3 && element.No3.length > 0">
          <div class="value-container">
            <div *ngFor="let value of element.No3; let i = index" class="value-item" [ngStyle]="{
              'background-color': (i === 0 && compareValues(value, tempValue, tempOperator)) || 
                       (i === 1 && compareValues(value, humValue, humOperator)) ? 'red' : 'inherit'
            }">
              <span>
                {{ i === 0 ? 'T: ' : i === 1 ? 'RH: ' : '' }}
              </span>
              <span>
                {{ value | number: '1.0-0' }}
              </span>  
                          <span>
                {{ i === 0 ? '°C' : i === 1 ? '%' : '' }}
              </span>
            </div>
          </div>
          <small class="time-label">{{ element.Date3 | date: 'shortTime' }}</small>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="No4">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold">No. 4</th>
      <td mat-cell *matCellDef="let element" class="FontBold compact-cell" [class.empty-cell]="element.No4.length == 0">
        <ng-container *ngIf="element.No4 && element.No4.length > 0">
          <div class="value-container">
            <div *ngFor="let value of element.No4; let i = index" class="value-item" [ngStyle]="{
              'background-color': (i === 0 && compareValues(value, tempValue, tempOperator)) || 
                       (i === 1 && compareValues(value, humValue, humOperator)) ? 'red' : 'inherit'
            }">
              <span>
                {{ i === 0 ? 'T: ' : i === 1 ? 'RH: ' : '' }}
              </span>
              <span>
                {{ value | number: '1.0-0' }}
              </span>  
                          <span>
                {{ i === 0 ? '°C' : i === 1 ? '%' : '' }}
              </span>
            </div>
          </div>
          <small class="time-label">{{ element.Date4 | date: 'shortTime' }}</small>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="No5">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold">No. 5</th>
      <td mat-cell *matCellDef="let element" class="FontBold compact-cell" [class.empty-cell]="element.No5.length == 0">
        <ng-container *ngIf="element.No5 && element.No5.length > 0">
          <div class="value-container">
            <div *ngFor="let value of element.No5; let i = index" class="value-item" [ngStyle]="{
              'background-color': (i === 0 && compareValues(value, tempValue, tempOperator)) || 
                       (i === 1 && compareValues(value, humValue, humOperator)) ? 'red' : 'inherit'
            }">
              <span>
                {{ i === 0 ? 'T: ' : i === 1 ? 'RH: ' : '' }}
              </span>
              <span>
                {{ value | number: '1.0-0' }}
              </span>  
                          <span>
                {{ i === 0 ? '°C' : i === 1 ? '%' : '' }}
              </span>
            </div>
          </div>
          <small class="time-label">{{ element.Date5 | date: 'shortTime' }}</small>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="No6">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold">No. 6</th>
      <td mat-cell *matCellDef="let element" class="FontBold compact-cell" [class.empty-cell]="element.No6.length == 0">
        <ng-container *ngIf="element.No6 && element.No6.length > 0">
          <div class="value-container">
            <div *ngFor="let value of element.No6; let i = index" class="value-item" [ngStyle]="{
              'background-color': (i === 0 && compareValues(value, tempValue, tempOperator)) || 
                       (i === 1 && compareValues(value, humValue, humOperator)) ? 'red' : 'inherit'
            }">
              <span>
                {{ i === 0 ? 'T: ' : i === 1 ? 'RH: ' : '' }}
              </span>
              <span>
                {{ value | number: '1.0-0' }}
              </span>  
                          <span>
                {{ i === 0 ? '°C' : i === 1 ? '%' : '' }}
              </span>
            </div>
          </div>
          <small class="time-label">{{ element.Date6 | date: 'shortTime' }}</small>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="Remark">
        <th mat-header-cell *matHeaderCellDef class="text-center FontBold compact-header">Remark</th>
        <td mat-cell *matCellDef="let element" class="FontBold remark-cell">
            <div *ngFor="let remark of element.Remark.slice(0, 3)" class="remark-item">
                <span [ngStyle]="{'color': remark.type === 'temp' ? '#ff4444' : '#e39304'}" class="remark-value">
                    {{ remark.type === 'temp' ? 'Temp: ' : 'RH: ' }}{{ remark.value }}{{ remark.type === 'temp' ? '°C' : '%' }}
                    <small class="remark-time">({{remark.date | date:'shortTime'}})</small>
                </span>
            </div>

            <div *ngIf="expandedRows[element.day]" class="expanded-remarks">
                <div *ngFor="let remark of element.Remark.slice(3)" class="remark-item">
                    <span [ngStyle]="{'color': remark.type === 'temp' ? '#ff4444' : '#e39304'}" class="remark-value">
                        {{ remark.type === 'temp' ? 'Temp: ' : 'RH: ' }}{{ remark.value }}{{ remark.type === 'temp' ? '°C' : '%' }}
                        <small class="remark-time">({{remark.date | date:'shortTime'}})</small>
                    </span>
                </div>
            </div>

            <button *ngIf="element.Remark.length > 3" 
                    mat-button 
                    color="primary"
                    class="show-more-btn"
                    (click)="toggleRow(element.day)">
                {{ expandedRows[element.day] ? 'Show Less' : 'Show More (' + (element.Remark.length - 3) + ')' }}
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['ItemData']"></tr>
    <tr mat-header-row *matHeaderRowDef="['dateHeader']"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
   <!-- <table id="pdfTable" mat-table [dataSource]="dataSource" class="mat-elevation-z8 full-border-table text-center">

    <tr mat-header-row>
      <th class="text-center FontBold" colspan="9">
       month & Year
      </th>
    </tr>

    <ng-container matColumnDef="Day">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> Day </th>
      <td mat-cell *matCellDef="let element"  class="FontBold"> {{element.day}} </td>
    </ng-container>

    <ng-container matColumnDef="No1">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 1 </th>
      <td mat-cell *matCellDef="let element" class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No1 !== NormalValue,
          'low-value': element.No1 === NormalValue
        }">
          {{element.No1}} <br> {{element.Date1 | date:'shortTime'}}
        </span>
  
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
          'high-value': element.No1 > NormalValue,
          'low-value': element.No1 <= NormalValue
        }">
          {{element.No1}} <br> {{element.Date1 | date:'shortTime'}}
        </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="No2">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 2 </th>
      <td mat-cell *matCellDef="let element"  class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No2 !== NormalValue,
          'low-value': element.No2 === NormalValue
        }">
        {{element.No2}} <br> {{element.Date2 | date:'shortTime'}}
      </span>

      <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
        'high-value': element.No2 > NormalValue,
        'low-value': element.No2 <= NormalValue
      }">
        {{element.No2}} <br> {{element.Date2 | date:'shortTime'}}
      </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="No3">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 3 </th>
      <td mat-cell *matCellDef="let element" class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No3 !== NormalValue,
          'low-value': element.No3 === NormalValue
        }">
        {{element.No3}} <br> {{element.Date3 | date:'shortTime'}}
      </span>

      <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
        'high-value': element.No3 > NormalValue,
        'low-value': element.No3 <= NormalValue
      }">
        {{element.No3}} <br> {{element.Date3 | date:'shortTime'}}
      </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="No4">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 4 </th>
      <td mat-cell *matCellDef="let element" class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No4 !== NormalValue,
          'low-value': element.No4 === NormalValue
        }">
        {{element.No4}} <br> {{element.Date4 | date:'shortTime'}}
      </span>

      <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
        'high-value': element.No4 > NormalValue,
        'low-value': element.No4 <= NormalValue
      }">
        {{element.No4}} <br> {{element.Date4 | date:'shortTime'}}
      </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="No5">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 5 </th>
      <td mat-cell *matCellDef="let element" class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No5 !== NormalValue,
          'low-value': element.No5 === NormalValue
        }">
        {{element.No5}} <br> {{element.Date5 | date:'shortTime'}}
      </span>

      <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
        'high-value': element.No5 > NormalValue,
        'low-value': element.No5 <= NormalValue
      }">
        {{element.No5}} <br> {{element.Date5 | date:'shortTime'}}
      </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="No6">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 6 </th>
      <td mat-cell *matCellDef="let element" class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No6 !== NormalValue,
          'low-value': element.No6 === NormalValue
        }">
        {{element.No6}} <br> {{element.Date6 | date:'shortTime'}}
      </span>

      <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
        'high-value': element.No6 > NormalValue,
        'low-value': element.No6 <= NormalValue
      }">
        {{element.No6}} <br> {{element.Date6 | date:'shortTime'}}
      </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="No7">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 7 </th>
      <td mat-cell *matCellDef="let element" class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No7 !== NormalValue,
          'low-value': element.No7 === NormalValue
        }">
        {{element.No7}} <br> {{element.Date7 | date:'shortTime'}}
      </span>

      <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
        'high-value': element.No7 > NormalValue,
        'low-value': element.No7 <= NormalValue
      }">
        {{element.No7}} <br> {{element.Date7 | date:'shortTime'}}
      </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="No8">
      <th mat-header-cell *matHeaderCellDef class="text-center FontBold"> No. 8 </th>
      <td mat-cell *matCellDef="let element" class="FontBold">
        <span *ngIf="AddMeasurerItemsForm.get('ItemType').value === 3" [ngClass]="{
          'high-value': element.No8 !== NormalValue,
          'low-value': element.No8 === NormalValue
        }">
        {{element.No8}} <br> {{element.Date8 | date:'shortTime'}}
      </span>

      <span *ngIf="AddMeasurerItemsForm.get('ItemType').value !== 3" [ngClass]="{
        'high-value': element.No8 > NormalValue,
        'low-value': element.No8 <= NormalValue
      }">
        {{element.No8}} <br> {{element.Date8 | date:'shortTime'}}
      </span>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="ItemData">
      <td mat-header-cell *matHeaderCellDef colspan="12" fxLayout="row" fxLayoutAlign="space-between center" class="text-center mb-2">
        <div fxFlex="33">
          <strong>Code: </strong><span class="PassColor">{{code}}</span>
        </div>
        <div fxFlex="33">
          <strong>Name: </strong><span class="FailColor">{{name}}</span>
        </div>
        <div fxFlex="33">
          <strong>Branch: </strong><span class="FailColor">{{branch}}</span>
        </div>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="dateHeader">
      <td mat-header-cell *matHeaderCellDef colspan="12" fxLayout="row" fxLayoutAlign="space-between center" class="text-center mb-2">
        <div fxFlex="50">
          <strong>Month: </strong><span class="PassColor">{{month}}</span>
        </div>
        <div fxFlex="50">
          <strong>Year: </strong><span class="FailColor">{{year}}</span>
        </div>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="['ItemData']"></tr>
    <tr mat-header-row *matHeaderRowDef="['dateHeader']"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
  </table> -->
  
  
</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



